import { render, staticRenderFns } from "./subid.vue?vue&type=template&id=671d61eb&lang=pug&"
import script from "./subid.vue?vue&type=script&lang=js&"
export * from "./subid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports